:host {
  --font-family: var(--font-family-secondary);
}

gz-tree {
  width: 100%;
  --node-name-font-size: var(--body-size-medium);
}

.wrapper {
  display: block;
}

.tree-loader {
  margin-bottom: var(--spacer);
}
